import { useState } from 'react';

import { PrimaryMarketCalculatorModal } from './PrimaryMarketCalculatorModal';

import { ReactComponent as CalculatorIcon } from 'assets/icons/calculator-icon.svg';

import styles from './index.module.scss';

export const PrimaryMarketCalculator = () => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div>
			<button onClick={() => setIsOpen((prev) => !prev)} className={styles.icon}>
				<CalculatorIcon />
			</button>

			<PrimaryMarketCalculatorModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</div>
	);
};
